import React from 'react'
import "./ManualAlert.css"

const ManualAlertpage = ({ message, context, btnname, close, togglebox,context2 }) => {

    return (
        
        <>
            <div className="alertbox" style={{ display: close ? "hidden" : "flex" }}>
                <div className="alertbox-underdiv">
                    <div className="success-container">
                        <div class="tick-mark">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="100" height="100">
                                <path class="tick" d="M10 25 L20 35 L40 15" stroke="green" stroke-width="4" fill="transparent" />
                            </svg>
                        </div>
                    </div>
                    <h2>{message}</h2>
                    <p dangerouslySetInnerHTML={{__html:context}}></p>
                    <p className='context2' dangerouslySetInnerHTML={{__html:context2}}></p>
                    <button onClick={togglebox}>{btnname}</button>
                </div>
            </div>
        </>
    )
}

export default ManualAlertpage
